export default {
  subtitle:
    "Sumérjase en el cumplimiento de la CBAM, los cálculos de emisiones de carbono y las mejores prácticas de la industria",
  no_posts: "No hay artículos disponibles",
  loading: "Cargando...",
  read_time: "{minutes} minutos de lectura",
  minute: "min",
  share: "Compartir:",
  back_to_list: "Volver a la lista de blogs",
  article_not_found: "Artículo no encontrado",
  article_not_found_desc: "Lo sentimos, el artículo que está buscando no existe",
  cta_title: "¿Listo para comenzar su viaje de cumplimiento de la CBAM?",
  cta_subtitle:
    "Pruebe TaxEcoBit ahora para generar fácilmente informes de emisiones de carbono compatibles con la UE",
  cta_button: "Probar ahora",
};
